// src/services/busquedaService.js

import { busquedaAvanzadaJWT, busquedaAvanzadaExportarJWT } from '../api/endpoints';

const busquedaService = {
    /**
     * Buscar expedientes con filtros avanzados.
     *
     * El `limit` por defecto es 500 a propósito: es el tope que tenía la búsqueda
     * avanzada antes de que se le agregara paginado, y lo usan Readjudicación Masiva
     * y useBusquedaAvanzada, que arman un lote con TODO lo que devuelve la búsqueda.
     * Bajarlo al default de 100 del endpoint les recortaría los lotes en silencio.
     * La respuesta ahora incluye `total` con el total real de coincidencias.
     */
    async buscarExpedientes(filtros, tipoExpediente, limit = 500, offset = 0) {
        try {
            return await busquedaAvanzadaJWT(filtros, tipoExpediente, limit, offset);
        } catch (error) {
            console.error('Error en búsqueda de expedientes:', error);
            throw error;
        }
    },

    /**
     * Trae SOLO los ids de todo lo que coincide con los filtros, sin el tope de 500.
     * Lo usa Readjudicación Masiva para armar lotes grandes: los del sistema viejo
     * llegan a 5.459 expedientes y no entran en una página de resultados.
     * El backend topea en 25.000 y devuelve el `total` real para detectar el recorte.
     */
    async buscarIds(filtros, tipoExpediente) {
        try {
            return await busquedaAvanzadaJWT(filtros, tipoExpediente, 0, 0, true);
        } catch (error) {
            console.error('Error obteniendo ids de expedientes:', error);
            throw error;
        }
    },

    async exportarExcel(expedientesIds, filtros, tipoExpediente) {
        try {
            const response = await busquedaAvanzadaExportarJWT(expedientesIds, tipoExpediente);

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Expedientes_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            return blob;
        } catch (error) {
            console.error('Error al exportar a Excel:', error);
            throw error;
        }
    }
};

export default busquedaService;
